import { RouteInfo } from "./sidebar.metadata";
export const ROUTES: RouteInfo[] = [

  {
    path: "/dashboard/dashboard",
    title: "Dashboard",
    moduleName: "dashboard",
    iconType: "feather",
    icon: "monitor",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["Dashboard"],
    submenu: [],
  },

  // {
  //   path: "/account/supplier-profile",
  //   title: "Profile",
  //   moduleName: "dashboard",
  //   iconType: "feather",
  //   icon: "person",
  //   class: "",
  //   groupTitle: false,
  //   badge: "",
  //   badgeClass: "",
  //   role: ["All"],
  //   privilege: ["Dashboard"],
  //   submenu: [],
  // },

  //Recieve Appications
  {
    path: "",
    title: "RFPs",
    moduleName: "recieverfqapplication",
    iconType: "feather",
    icon: "description",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["All Rfq Applications"],
    submenu: [
      {
        path: "/rfps/all",
        title: "View RFPs",
        moduleName: "rfps",
        iconType: "feather",
        icon: "visibility",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: ["All"],
        privilege: ["All Rfq Applications"],
        submenu: [],
      },
      {
        path: "/rfps/view-rfps-applications",
        title: "RFP Applications",
        moduleName: "rfps",
        iconType: "feather",
        icon: "layers",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: ["All"],
        privilege: ["All Rfq Applications"],
        submenu: [],
      },
    ],
  },

  //Requisition
  {
    path: "",
    title: "RFQs",
    moduleName: "rfqs",
    iconType: "feather",
    icon: "assignment",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["Approved Requisitions", "All Rfqs", "Manage Rfqs"],
    submenu: [
      {
        path: "/rfqs/all",
        title: "All Rfqs",
        moduleName: "rfqs",
        iconType: "feather",
        icon: "list",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: ["All"],
        privilege: ["All Rfqs"],
        submenu: [],
      },
      {
        path: "/rfqs/view-applications",
        title: "RFQ Applications",
        moduleName: "rfqs",
        iconType: "feather",
        icon: "check_box",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: ["All"],
        privilege: ["Manage Rfqs"],
        submenu: [],
      },
    ],
  },

  {
    path: "/orders",
    title: "Purchase Orders",
    moduleName: "purchaseorders",
    iconType: "feather",
    icon: "shopping_cart",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["All Purchaseorders", "Manage Purchaseorders"],
    submenu: [],
  },

  {
    path: "/supplier-faq/board",
    title: "Q&A Support",
    moduleName: "supplier-faq",
    iconType: "material",
    icon: "forum",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["All"],
    submenu: [],
  },

  {
    path: "",
    title: "Invoices",
    moduleName: "Invoice",
    iconType: "feather",
    icon: "credit_card",
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    role: ["All"],
    privilege: ["All Budget Categories", "Manage Branch Stores"],
    submenu: [
      {
        path: "/invoicing/view-invoices",
        title: "All Invoices",
        moduleName: "Invoice",
        iconType: "feather",
        icon: "description",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: ["All"],
        privilege: ["Manage Purchaseorders"],
        submenu: [],
      },

      {
        path: "/invoicing/add",
        title: "Manage Invoice",
        moduleName: "Invoice",
        iconType: "feather",
        icon: "add_box",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        role: ["All"],
        privilege: ["All Rfq Applications"],
        submenu: [],
      },
    ],
  },
];